import http from './index';

const requests = function (axiosInstance) {
  return {
    getActiveCodeGroups: async () => {
      return axiosInstance.get('/codeGroups/active');
    },
    getCodeGroups: async (query = {}) => {
      return axiosInstance.get('/codeGroups/list', {params: query});
    },
    enableCodeGroup: async (id) => {
      return axiosInstance.post(`/codeGroups/${id}/enable`);
    },
    disableCodeGroup: async (id) => {
      return axiosInstance.post(`/codeGroups/${id}/disable`);
    },
  };
};

export default {
  ...requests(http)
};

module.exports.codeGroupsRequests = requests;
